import React from 'react';
import { Star } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
const REVIEWS = [{
  name: 'Douglas Forrest',
  text: 'They listened to our design scheme and colors perfectly. The proofing process before ordering gave us total confidence.'
}, {
  name: 'Dani Villanueva',
  text: "High quality uniforms and incredibly helpful support. The process was much easier than other companies we've used."
}, {
  name: 'Melissa Myers',
  text: 'Great price and value. The uniforms arrived on time and looked exactly like the mockups we approved.'
}, {
  name: 'Scott Haynes',
  text: 'Reliable experience from start to finish. The team stores made it so easy for parents to order their own gear.'
}];
export function ReviewsSection() {
  return <section className="py-20 bg-white border-t border-gray-200" data-id="element-209">
      <Container data-id="element-210">
        <div className="text-center mb-16" data-id="element-211">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4 text-gray-900" data-id="element-212">
            Trusted By Teams Nationwide
          </h2>
          <div className="w-24 h-1.5 bg-pts-red mx-auto mb-6" data-id="element-213"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-214">
          {REVIEWS.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-gray-50 p-6 rounded-xl border border-gray-100 shadow-sm flex flex-col h-full" data-id="element-215">
              <div className="flex text-pts-red mb-4" data-id="element-216">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" data-id="element-217" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-218">
                "{review.text}"
              </p>
              <div className="font-oswald font-bold uppercase text-gray-900" data-id="element-219">
                {review.name}
              </div>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}